import BossModel from "@/models/BossModel";
import Version from '@/models/WebsitePage/Version/Version'
import WebsiteRoute from "@/models/WebsiteRoute/WebsiteRoute";
import {sortBy} from "lodash";
import Region from "@/models/Region/Region.js";
import WebsiteFeaturedArticle from "@/models/WebsiteFeaturedArticle/WebsiteFeaturedArticle";
import WebsiteBrandPillarPage from "@/models/WebsiteBrandPillarPage/WebsiteBrandPillarPage";


export default class WebsitePage extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-page';

    /**
     *
     * @type {string}
     */
    static entity = 'websitePages';

    static fields() {
		return {
			id: this.number(null).nullable(),
			name: this.attr(null),
			url: this.attr(null),
			parent_id: this.number(null).nullable(),
            region_id: this.number(null).nullable(),
			website_page_version_id: this.number(null).nullable(),
			deleted_at: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
            parents: this.belongsTo(WebsitePage, 'parent_id'),
            version: this.belongsTo(Version, 'website_page_version_id'),
            versions: this.hasMany(Version, 'website_page_id'),
            oldestVersion: this.hasOne(Version, 'website_page_id'),
            websiteRoute: this.hasOne(WebsiteRoute, 'routeable_id'),
            region: this.belongsTo(Region),
            featuredArticle: this.hasOne(WebsiteFeaturedArticle, 'website_page_id'),
            websiteBrandPillarPage: this.hasOne(WebsiteBrandPillarPage, 'website_page_id'),
		}
	}

    static search(params = {}) {
        return this.api()
            .filtered(params.filters)
            .limit(0)
            .get().then((data) => {
                let pages = [];
                for (let key in data) {
                    pages.push(new WebsitePage(data[key]));
                }
                return pages;
            });
    }

    Parents() {
        if (this.parents !== undefined && Array.isArray(this.parents)) {
            return this.parents;
        }

        const parents = [];
        let current = this.Parent();

        while (current) {
            parents.push(current);
            current = current.Parent();
        }

        this.parents = parents.reverse();

        return this.parents;
    }

    /**
     *
     * @returns {string}
     * @constructor
     */
    FullUrl() {
        let fullUrl = '';
        let parents = this.Parents();

        for (let key in parents) {
            fullUrl += '/' + parents[key].url;
        }

        return fullUrl + '/' + (this.url ? this.url : '');
    }

    static byParentId(parentId) {
        return this.query().orderBy('name').where('parent_id',parentId).get();
    }

    static makeTree(nodes, parentId = null) {
        return nodes
            .filter((node) => node.parent_id === parentId)
            .reduce(
                (tree, node) => [
                    ...tree,
                    {
                        ...node,
                        children: this.makeTree(sortBy(nodes,['name']), node.id),
                    },
                ],
                [],
            )
    }

    /**
     *
     * @returns {boolean}
     * @constructor
     */
    AreChildrenAllowed() {
        return !this.Parent() || !this.Parent().Parent() || !this.Parent().Parent().Parent();
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    Parent() {
        return this.getRelated('parents');
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Versions() {
        return this.getRelated('versions');
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    Version() {
        return this.getRelated('version');
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    WebsiteRoute() {
        return WebsiteRoute.findByRouteable(this.id, 'website_page');
    }
}
